module.exports = __webpack_public_path__ + "img/CAT.19e4d84.svg";